var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"alt":"Loading icon","src":"/assets/images/wila-loader.svg"}})])
}]

export { render, staticRenderFns }